var MetadataInfo = /** @class */ (function () {
    function MetadataInfo(abc, name, keys, values) {
        this.abc = abc;
        this.name = name;
        this.keys = keys;
        this.values = values;
        // ...
    }
    MetadataInfo.prototype.getName = function () {
        if (typeof this.name === 'number') {
            this.name = this.abc.getString(this.name);
        }
        return this.name;
    };
    MetadataInfo.prototype.getKeyAt = function (i) {
        return this.abc.getString(this.keys[i]);
    };
    MetadataInfo.prototype.getValueAt = function (i) {
        return this.abc.getString(this.values[i]);
    };
    MetadataInfo.prototype.getValue = function (key) {
        for (var i = 0; i < this.keys.length; i++) {
            if (this.abc.getString(this.keys[i]) === key) {
                return this.abc.getString(this.values[i]);
            }
        }
        return null;
    };
    return MetadataInfo;
}());
export { MetadataInfo };
